<template>
    <div class="rsu">
      <div style="display:flex;flex-direction: column;gap:16px;padding:0px;">
        <div v-for="(formitem, k) in formdata.formitems || formdata" :key="k" class="form-control">
          <div v-if="['หัวข้อ'].includes(formitem.questiontype)">
            <div style="font-weight: 600;font-size: 20px;color: #2C2C2C;margin-bottom: 10px;">
              {{ formitem.name }}
            </div>
            <v-divider></v-divider>
          </div>
  
          <div v-else-if="formitem.questiontype === 'ข้อความ'">
            <div class="input-ans">
              <Typography
                h5
                semiBold
                color="darkGrey"
                :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
                :label="formitem.name"
              />
              <input
                :name="'form' + k"
                :placeholder="customPlaceholder(formitem.defaultOptions)"
         
                v-model="formitem.Options"
                @input="update('Options', $event.target.value, k)"
                type="text"
                class="depainput rsu mb-0"
              />
            </div>
          </div>
  
          <div
            v-else-if="
              ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(formitem.questiontype)
            "
          >
            <div>
              <Typography
                h5
                semiBold
                color="darkGrey"
                :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
                :label="formitem.name"
              />
              <div class="form-control">
                <div style="position: relative">
                  <input
                    :value="formitem.value ? formitem.value.length + ' ' + 'ไฟล์' : '0 ไฟล์'"
                    class="depainput rsu pl-5"
                    type="text"
                    style="display:none;"
                  />
                  <UploadDocument
                    v-model="formitem.value"
                    @onUploaded="onClickUploadFile($event,k)"
                    v-validate="'required'"
                    :multiple="formitem.isMultiple"
                    :showOnlyButton="true"
                  >
                    <template v-slot="{ loading }">
                      <v-btn
                        class="rsu customConfirmBtn ma-0 uploadBtn"
                        round
                        depressed
                        color="primary"
                        :loading="loading"
                      >
                        <img
                          :src="`/static/icon/uploadYellowSvg.svg`"
                          alt
                          class="responsive-img mr-2"
                          style="height: 13px;"
                        />
                        {{ formitem.questiontype }}
                      </v-btn>
                    </template>
                  </UploadDocument>
                  <div
                    v-if="formitem.value"
                    style="font-weight: 500;font-size: 12px;color: #BDBDBD;margin-top: 10px;"
                  >
                    (จำนวนไฟล์ที่อัปโหลดแล้ว : {{ formitem.value.length }} ไฟล์)
                  </div>
                  <div
                    v-else
                    style="font-weight: 500;font-size: 12px;color: #BDBDBD;margin-top: 10px;"
                  >
                    (จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)
                  </div>
                </div>
              </div>
            </div>
  
            <div v-for="(item, index) in formitem.value" :key="index" style="width: 100%">
              <div
                class="text-truncate"
                style="display:flex;flex-direction: row;gap:8px;align-items: center;"
              >
                <span
                  style="font-size: 12px;font-weight:700; color:#26588B; cursor: pointer;"
                  @click="showItem(item)"
                >
                  {{ showNameFormLink(item) }}
                </span>
                <span @click="deleteItem(index, k)">
                  <img
                    src="/static/img/delete.png"
                    alt
                    style="width:13px;height:15px;cursor: pointer;"
                  />
                </span>
              </div>
            </div>
          </div>
          <div v-else-if="formitem.questiontype == 'เลื่อนลง'">
            <Typography
              h5
              semiBold
              color="darkGrey"
              :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`"
              :label="formitem.name"
            />
            <DropdownMenu
              v-model="formitem.Options"
              :options="formitem.fields"
              :textLabel="'label'"
              :textValue="'label'"
            >
              <div style="position: relative" class="form-control">
                <input
                  :value="formitem.Options ? formitem.Options : formitem.defaultOptions"
                  placeholder="เลือก"
                  type="text"
                  class="option-input rsu"
                  style="cursor: pointer"
                />
              </div>
            </DropdownMenu>
          </div>
  
          <div v-else-if="['บทความ'].includes(formitem.questiontype)">
            <Typography
              h5
              semiBold
              color="darkGrey"
              :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
              :label="formitem.name"
            />
            <textarea
              :name="'คำถาม' + k"
              :data-vv-as="'คำถาม'"
              v-validate="'required'"
              :value="formitem.Options"
              @input="update('Options', $event.target.value,k)"
              placeholder="กรอกบทความ"
              type="text"
              class="rsu mb-0"
              rows="6"
              style="height: auto !important;padding: 12px !important;margin: 0;resize: none;"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
  import DropdownMenu from '@/components/elements/DropdownMenu.vue'
  import uploadfile from '@/components/elements/uploadfile.vue'
  import UploadDocument from '@/components/elements/UploadDocument.vue'
  import uploadalltype from '@/components/elements/uploadalltype'
  import draggable from 'vuedraggable'
  import Typography from '@/components/elements/Typography.vue'
  export default {
    props: ['formdata', 'showPreview'],
  
    components: {
      AutoresizeTextarea,
      DropdownMenu,
      uploadfile,
      UploadDocument,
      Typography,
      uploadalltype,
      draggable: {
        extends: draggable
      }
    },
    data() {
      return {
        defaultAnswerOptions: [
          { label: '(ไม่มี)', value: '' },
          { label: 'ชื่อ', value: 'name' },
          { label: 'อีเมล', value: 'email' },
          { label: 'เบอร์โทรศัพท์', value: 'phone_number' },
          { label: 'หมายเลขบัตรประชาชน', value: 'id_card' },
          { label: 'เลขทะเบียนนิติบุคคล', value: 'id_card2' },
          { label: 'เลขประจำตัวผู้เสียภาษีอากร', value: 'id_card3' },
          { label: 'ทุนจดทะเบียน', value: 'regis_cap' },
          { label: 'ประเภทนิติบุคคล', value: 'membertype' },
          { label: 'Project Name', value: 'project_name' },
          { label: 'Member Type', value: 'membertype2' },
          { label: 'DP Status', value: 'dptype' },
          { label: 'Register Capital', value: 'RegisterCapital' },
          { label: 'Paid Register Capital', value: 'PaidRegisterCapital' },
          { label: 'เลขเกษตรกร', value: 'farmer_number' },
          { label: 'Member ID', value: 'u_memberid' },
          { label: '[Tech hunt] รหัสคูปอง (voucher)', value: 't_product_voucher' },
          { label: '[Tech hunt] ชื่อร้านค้า (DP) ', value: 't_shop_name' },
          { label: '[Tech hunt] ชื่อสินค้า', value: 't_product' },
          { label: '[Tech hunt] ประเภทสินค้า', value: 't_product_type' },
          { label: '[Tech hunt] หมวดหมู่สินค้า', value: 't_product_category' },
          { label: '[Tech hunt] member id ของ DP', value: 'shop_memberid' },
          { label: '[Tech hunt] เลขทะเบียนนิติบุคคลของ DP', value: 'shop_juristic_id' },
          { label: '[Tech hunt] หน่วยร่วม', value: 'agency' }
        ],
        nativeSelectedItems: [],
        menu: false,
  
        optionsStatus: ['กล่องข้อความ', 'หลายตัวเลือก', 'เลื่อนลง', 'ช่องทำเครื่องหมาย'],
        input: {
          name: '',
          questiontype: 'ช่องทำเครื่องหมาย',
          fields: [''],
          fields2: ['']
        }
      }
    },
    mounted: function() {},
    computed: {
      isReadonly() {
        return false
      }
    },
    inject: ['$validator'],
    methods: {
      update(key, value, k) {
        this.$emit('input', { ...this.formdata.formitems[k], [key]: value })
      },
      onClickUploadFile(url,k) {
        this.update('value', url,k)
      },
      customPlaceholder(text) {
        for (let i = 0; i < this.defaultAnswerOptions.length; i++) {
          if (this.defaultAnswerOptions[i].value === text) {
            if (text != ('(ไม่มี)' && '' && null && undefined)) {
              return `(${this.defaultAnswerOptions[i].label})`
            } else {
              return ``
            }
          }
        }
      },
      showNameFormLink(link) {
        try {
          let tempLink = decodeURI(link)
          tempLink = tempLink.split('/')
          tempLink = tempLink[tempLink.length - 1]
          tempLink = tempLink.split('_')
          tempLink.shift()
          tempLink = tempLink.join('_')
          return tempLink
        } catch (error) {
          return link
        }
      },
      showItem(item) {
        window.open(item, '_blank').focus()
      },
      deleteItem: function(index, k) {
        var result = this.formdata.formitems
        var data_file = result[k].value
        data_file.splice(index, 1)
      }
    },
    filters: {
      showFilename(value) {
        var result = value
        if (result) {
          result = result.split('/')
          result = result[4].substring(13)
        }
        return result
      }
    }
  }
  </script>
  <style scoped>
  .header-form {
    font-weight: 600;
    font-size: 16px;
    color: #2c2c2c;
  }
  .input-form {
    height: 38px !important;
    width: 100% !important;
    background: #ffffff !important;
    border: 1px solid #2c2c2c !important;
    border-radius: 6px !important;
    padding-left: 14px !important;
    color: #26588b !important;
    outline: none !important;
    box-shadow: none !important;
  }
  .button-select {
    background: #ffffff;
    border: 1px solid #2c2c2c !important;
    border-radius: 6px !important;
    /* height: 38px; */
    outline: none;
    padding-top: 0px !important;
    margin-top: 0px !important;
  }
  .form-detailmember {
    background: #fff;
    border-radius: 0px 0px 8px 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .customConfirmBtn {
    color: yellow !important;
    font-weight: 700;
    font-size: 16px;
    width: 142px;
    margin: 0 7px;
  }
  .dataReq {
    display: flex;
  }
  .dataReq::after {
    content: '*';
    color: red;
  }
  .uploadBtn {
    width: 185px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/view/projectMaster/AddMemberForm/FormAddDetailSubquestion.vue